module.exports = __webpack_public_path__ + "static/images/leaflet/layers-2x.png";